
import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const ScrollParagraph = ({ value, className }) => {
    const element = useRef(null);
    const { scrollYProgress } = useScroll({
        target: element,
        offset: ['start 0.9', 'start 0.9']
    });

    const words = value.split(" ");

    return (
        <p
            ref={element}
            className={`flex flex-wrap ${className}`}
            style={{ lineHeight: 1.6 }}
        >
            {words.map((word, i) => {
                const start = i / words.length;
                const end = start + (1 / words.length);
                return (
                    <Word key={i} progress={scrollYProgress} range={[start, end]}>
                        {word}
                    </Word>
                );
            })}
        </p>
    );
};

const Word = ({ children, progress, range }) => {
    const opacity = useTransform(progress, range, [0.9, 1]);

    return (
        <span className="relative mr-1.5 mt-1">
            <motion.span style={{ opacity }} className="text-secondary">
                {children}
            </motion.span>
        </span>
    );
};

export default ScrollParagraph;
